import { FeatureContext } from '@monash/portal-frontend-common';
import { useContext } from 'react';

// This hook converts any additionalOptions that are functions
// and calls them with featureFlags. This is a work around to allow
// us to use featureFlags within additionalOptions in each widget module
export const useAdditionalOptions = (additionalOptions) => {
  const { featureFlags } = useContext(FeatureContext);

  if (typeof additionalOptions !== 'function') {
    return additionalOptions;
  }

  return additionalOptions({ featureFlags });
};
